import View from "../../../Nav/Js/views/StrateAsyncView";
import components from "./components.js";
components.define("js-StrateAsync", View);